module.exports = __webpack_public_path__ + "img/img_info.0231d25a.png";